// Image imports
import yoramMetzgerPortrait from '../../../images/yoram.avif';

export const yoramMetzgerMemorial = {
  id: 20,
  name: 'Yoram Metzger',
  category: 'community-leaders',
  images: {
    portrait: yoramMetzgerPortrait
  },
  info: `

"He knew every inch of this land and loved it with all his heart." - Family member

# Yoram Metzger

![Yoram Metzger](${yoramMetzgerPortrait})
*Yoram Metzger, whose life was dedicated to Israel's land and people*

## A Son of the Land

Yoram Metzger was 80 years old when Hamas terrorists attacked Kibbutz Nir Oz on October 7th, 2023. A longtime resident of the kibbutz, Yoram had spent his entire adult life farming the land around the Gaza border, turning desert into productive fields through determination and agricultural expertise.

Like many in his generation, Yoram's life story was intertwined with the history of Israel itself. He had fought in its wars, cultivated its soil, and raised his family in a community just kilometers from Gaza, believing always in the possibility of a peaceful future.

## An Agricultural Pioneer

Friends and family remember Yoram as someone who embraced innovation in farming. He was among the first in the region to adopt drip irrigation techniques that conserved water while maximizing crop yields. His fields produced fruits and vegetables that were exported internationally, a source of great pride for him.

"Yoram could look at a patch of sand and envision an orchard," a fellow kibbutz member recalled. "And then, through sheer will and knowledge, he would make it happen."

In retirement, Yoram continued to advise younger farmers and would often be seen walking through the kibbutz's fields early in the morning, checking crops and offering suggestions. His knowledge was sought after, and he generously shared what he had learned through decades of working the land.

## A Family Legacy

Yoram and his wife had raised three children on the kibbutz, and by the time of his abduction, he had seven grandchildren. Family gatherings at his home were lively affairs, with Yoram often telling stories of the kibbutz's early days and the challenges they had overcome.

His grandchildren described him as patient and attentive, always interested in their lives and achievements. He taught them to appreciate nature, to understand where food comes from, and to respect the labor that produces it.

## A Final Chapter

On August 8, 2024, Israeli forces recovered Yoram's body along with five other elderly hostages from Gaza. After ten months in captivity, he had died without seeing his home or family again.

His funeral was held in Kibbutz Nir Oz, the community he had helped build and sustain throughout his life. Representatives from Israel's agricultural sector attended, acknowledging Yoram's contributions to farming techniques that had been adopted across the country.

May his memory be a blessing, and may the crops he planted continue to bear fruit.

`
};